// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-list__tile__action[data-v-43992862]{min-width:38px}.v-list--three-line .v-list__tile[data-v-43992862]{height:10px}", ""]);
// Exports
module.exports = exports;
